import React from 'react';

import { LibraryVideoProvider } from '@techchange/video';

import { RESOURCE_VIDEO_PROVIDERS } from '../../utils/constants';
import { contentBuilderPropTypes } from '../../utils/propTypes';

import ContentDisplay from './ContentDisplay';
import ContentEditor from './ContentEditor';

const propTypes = contentBuilderPropTypes.content;

const VideoContent = (props) => {

	const {
		data,
		resourceContent,
		isEditing,
		socket,
		triggers,
		userId,
		isAdmin,
		onCancel,
		onSave,
	} = props;

	const id = data.id;
	const type = data.type;
	const width = data.width;
	const showTitle = data.show_title;

	const initialValues = {
		title: resourceContent?.title,
		data: resourceContent?.data,
		width,
		language: data.language,
		resourceContents: data.resource_contents,
		deletedResourceContents: data.deleted_resource_contents,
		scope: data.scope,
		scope_id: data.scope_id,
	};

	return (
		<div>
			{isEditing &&
				<ContentEditor
					id={id}
					type={type}
					socket={socket}
					initialValues={initialValues}
					isNew={!data.created_at}
					onCancel={onCancel}
					onSave={onSave}
					onLanguageChange={triggers?.onLanguageChange}
					onWidthChange={triggers?.onWidthChange} />
			}
			{!isEditing &&
				<LibraryVideoProvider
					socket={socket}
					// Only a library-provider block has a video to fetch; a
					// stale video_id on any other provider would 400.
					videoId={
						resourceContent?.data?.provider === RESOURCE_VIDEO_PROVIDERS.LIBRARY
							? resourceContent?.data?.video_id
							: null
					}
					scope={data?.scope}
					scopeId={data?.scope_id}>
					<ContentDisplay
						id={id}
						data={resourceContent?.data}
						title={resourceContent?.title}
						userId={userId}
						isAdmin={isAdmin}
						showTitle={showTitle}
						onVideoWatch={triggers?.onVideoWatch} />
				</LibraryVideoProvider>
			}
		</div>
	);

};

VideoContent.propTypes = propTypes;

export default VideoContent;
